// PO redirect (2026-07-25) — keep the project workspace chrome on PO detail.
//
// Purchase-order detail now lives INSIDE its project's sub-nav
// (/projects/:projectId/pos/:poId) so the project workspace sub-nav tabs stay
// put when a rep follows a NextActionCta deep link to send a PO or add
// tracking. This wrapper keeps the legacy top-level
// `/pos/:id` URL (emails / bookmarks / global search) working: it resolves the
// PO's project and forwards into context.
//
// Unlike OrderRedirect, a PO's context CAN be null (production-only POs with no
// project). In that case we render the standalone detail page as a fallback
// rather than stranding the user. Reuses the detail page's ["pos", id,
// "detail"] query key so the fetch is shared, not duplicated.
//
// Mirrors OrderRedirect / PresentationRedirect (Nav Part 1, PR #160).
import { Navigate, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { PurchaseOrderDetailPage } from "@/pages/PurchaseOrderDetailPage";

interface RedirectPo {
  context: { projectId: string } | null;
}

export function PoRedirect() {
  const { id = "" } = useParams<{ id: string }>();
  const { data, isError } = useQuery({
    queryKey: ["pos", id, "detail"],
    queryFn: () => api<RedirectPo>(`/pos/${id}`),
    enabled: id.length > 0,
  });

  if (isError) return <Navigate to="/production/report" replace />;
  if (!data) {
    return (
      <div className="px-6 py-24 text-center text-sm text-brown-300">
        Opening PO…
      </div>
    );
  }

  // No project context (production-only PO) → render standalone, don't strand.
  if (!data.context) return <PurchaseOrderDetailPage />;

  return (
    <Navigate to={`/projects/${data.context.projectId}/pos/${id}`} replace />
  );
}
